import { render, staticRenderFns } from "./DocumentThumb.vue?vue&type=template&id=77b81b6f"
import script from "./DocumentThumb.vue?vue&type=script&lang=js"
export * from "./DocumentThumb.vue?vue&type=script&lang=js"
import style0 from "./DocumentThumb.vue?vue&type=style&index=0&id=77b81b6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports